import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "choicesWrapper", "choicesList", "choiceTemplate"]

  connect() {
    this.toggleChoices()
  }

  toggleChoices() {
    const value = this.typeSelectTarget.value
    const needsChoices = value === "single_choice" || value === "multiple_choice"
    if (needsChoices) {
      this.choicesWrapperTarget.classList.remove("hidden")
    } else {
      this.choicesWrapperTarget.classList.add("hidden")
    }
  }

  addChoice() {
    const template = this.choiceTemplateTarget
    const clone = template.content.cloneNode(true)
    const index = Date.now() + Math.floor(Math.random() * 1000)
    clone.querySelectorAll("[name]").forEach((el) => {
      el.name = el.name.replace("NEW_RECORD", index)
    })
    this.choicesListTarget.appendChild(clone)
  }
}
